// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZmbN","footer":"styles_footer__37oG0"};